import { render, staticRenderFns } from "./establishdialog.vue?vue&type=template&id=f9488bac&scoped=true"
import script from "./establishdialog.vue?vue&type=script&lang=js"
export * from "./establishdialog.vue?vue&type=script&lang=js"
import style0 from "./establishdialog.vue?vue&type=style&index=0&id=f9488bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9488bac",
  null
  
)

export default component.exports